<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <component v-else :is="userDashboard" :current-user="currentUser"></component>
</template>

<script>
import currentUserQuery from '@views/Dashboard/Main/queryCurrentUser.graphql';
import GenericDashboard from './Generic';

export default {
  name: 'dashboard',
  components: {
    GenericDashboard,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  computed: {
    userDashboard() {
      switch (this.currentUser.role.name) {
        default:
          return GenericDashboard;
      }
    },
  },
};
</script>
